import components_combo_box_locale0 from './generated/ar-AE.esm.js';
import components_combo_box_locale1 from './generated/bg-BG.esm.js';
import components_combo_box_locale2 from './generated/cs-CZ.esm.js';
import components_combo_box_locale3 from './generated/da-DK.esm.js';
import components_combo_box_locale4 from './generated/de-DE.esm.js';
import components_combo_box_locale5 from './generated/el-GR.esm.js';
import components_combo_box_locale6 from './generated/en-GB.esm.js';
import components_combo_box_locale7 from './generated/en-US.esm.js';
import components_combo_box_locale8 from './generated/es-ES.esm.js';
import components_combo_box_locale9 from './generated/et-EE.esm.js';
import components_combo_box_locale10 from './generated/fi-FI.esm.js';
import components_combo_box_locale11 from './generated/fr-FR.esm.js';
import components_combo_box_locale12 from './generated/he-IL.esm.js';
import components_combo_box_locale13 from './generated/hr-HR.esm.js';
import components_combo_box_locale14 from './generated/hu-HU.esm.js';
import components_combo_box_locale15 from './generated/it-IT.esm.js';
import components_combo_box_locale16 from './generated/ja-JP.esm.js';
import components_combo_box_locale17 from './generated/ko-KR.esm.js';
import components_combo_box_locale18 from './generated/lt-LT.esm.js';
import components_combo_box_locale19 from './generated/lv-LV.esm.js';
import components_combo_box_locale20 from './generated/nb-NO.esm.js';
import components_combo_box_locale21 from './generated/nl-NL.esm.js';
import components_combo_box_locale22 from './generated/pl-PL.esm.js';
import components_combo_box_locale23 from './generated/pt-BR.esm.js';
import components_combo_box_locale24 from './generated/pt-PT.esm.js';
import components_combo_box_locale25 from './generated/ro-RO.esm.js';
import components_combo_box_locale26 from './generated/ru-RU.esm.js';
import components_combo_box_locale27 from './generated/sk-SK.esm.js';
import components_combo_box_locale28 from './generated/sl-SI.esm.js';
import components_combo_box_locale29 from './generated/sr-SP.esm.js';
import components_combo_box_locale30 from './generated/sv-SE.esm.js';
import components_combo_box_locale31 from './generated/tr-TR.esm.js';
import components_combo_box_locale32 from './generated/uk-UA.esm.js';
import components_combo_box_locale33 from './generated/zh-CN.esm.js';
import components_combo_box_locale34 from './generated/zh-TW.esm.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-ignore
var components_combo_box_intlMessages = {};
components_combo_box_intlMessages['ar-AE'] = components_combo_box_locale0;
components_combo_box_intlMessages['bg-BG'] = components_combo_box_locale1;
components_combo_box_intlMessages['cs-CZ'] = components_combo_box_locale2;
components_combo_box_intlMessages['da-DK'] = components_combo_box_locale3;
components_combo_box_intlMessages['de-DE'] = components_combo_box_locale4;
components_combo_box_intlMessages['el-GR'] = components_combo_box_locale5;
components_combo_box_intlMessages['en-GB'] = components_combo_box_locale6;
components_combo_box_intlMessages['en-US'] = components_combo_box_locale7;
components_combo_box_intlMessages['es-ES'] = components_combo_box_locale8;
components_combo_box_intlMessages['et-EE'] = components_combo_box_locale9;
components_combo_box_intlMessages['fi-FI'] = components_combo_box_locale10;
components_combo_box_intlMessages['fr-FR'] = components_combo_box_locale11;
components_combo_box_intlMessages['he-IL'] = components_combo_box_locale12;
components_combo_box_intlMessages['hr-HR'] = components_combo_box_locale13;
components_combo_box_intlMessages['hu-HU'] = components_combo_box_locale14;
components_combo_box_intlMessages['it-IT'] = components_combo_box_locale15;
components_combo_box_intlMessages['ja-JP'] = components_combo_box_locale16;
components_combo_box_intlMessages['ko-KR'] = components_combo_box_locale17;
components_combo_box_intlMessages['lt-LT'] = components_combo_box_locale18;
components_combo_box_intlMessages['lv-LV'] = components_combo_box_locale19;
components_combo_box_intlMessages['nb-NO'] = components_combo_box_locale20;
components_combo_box_intlMessages['nl-NL'] = components_combo_box_locale21;
components_combo_box_intlMessages['pl-PL'] = components_combo_box_locale22;
components_combo_box_intlMessages['pt-BR'] = components_combo_box_locale23;
components_combo_box_intlMessages['pt-PT'] = components_combo_box_locale24;
components_combo_box_intlMessages['ro-RO'] = components_combo_box_locale25;
components_combo_box_intlMessages['ru-RU'] = components_combo_box_locale26;
components_combo_box_intlMessages['sk-SK'] = components_combo_box_locale27;
components_combo_box_intlMessages['sl-SI'] = components_combo_box_locale28;
components_combo_box_intlMessages['sr-SP'] = components_combo_box_locale29;
components_combo_box_intlMessages['sv-SE'] = components_combo_box_locale30;
components_combo_box_intlMessages['tr-TR'] = components_combo_box_locale31;
components_combo_box_intlMessages['uk-UA'] = components_combo_box_locale32;
components_combo_box_intlMessages['zh-CN'] = components_combo_box_locale33;
components_combo_box_intlMessages['zh-TW'] = components_combo_box_locale34;

export { components_combo_box_intlMessages as default };
//# sourceMappingURL=index.esm.js.map
